import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { errorEventAction } from "../actions/app.actions";
import { addDeviceToCompanyInventoryManagementFailedAction, addDeviceToCompanyInventoryManagementSuccessAction, addLocationToDeviceInventoryManagementFailedAction, addLocationToDeviceInventoryManagementSuccessAction, deleteDeviceFromCompanyInventoryManagementFailedAction, deleteDeviceFromCompanyInventoryManagementSuccessAction, deleteLocationToDeviceInventoryManagementFailedAction, deleteLocationToDeviceInventoryManagementSuccessAction, getAuthInfoInventoryManagementFailedAction, getAuthInfoInventoryManagementSuccessAction, getDevicesForCompanyInventoryManagementFailedAction, getDevicesForCompanyInventoryManagementSuccessAction, getLocationsInventoryManagementFailedAction, getLocationsInventoryManagementSuccessAction, InventoryManagementActionsTypes, updateDeviceNameInventoryManagementFailedAction, updateDeviceNameInventoryManagementSuccessAction } from "../actions/inventorymanagement.actions";
import { AuthenticationService, Device, InventoryManagementDevicePairingService, InventoryManagementDevicesService, InventoryManagementLocationsService, Location, PairingStatusResponse, PermissionsApi } from "src/app/generated/CrossPoint.InventoryManagement.Server";


@Injectable()
export class InventoryManagementEffects {

  public getAuthInfoProxyEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.GET_AUTH_INFO),
        exhaustMap(() => this.authenticationService.getPermissions()
          .pipe(
            map((permissions: PermissionsApi) => getAuthInfoInventoryManagementSuccessAction({ data: permissions.permissions })),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetAuthInfoInventoryManagementErrorHasOccurred" } }), getAuthInfoInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public getAllLocationsEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.GET_LOCATIONS),
        exhaustMap(({ data }) => this.inventoryManagementLocationsService.getAllLocations(data)
          .pipe(
            map((locations: Location[]) => getLocationsInventoryManagementSuccessAction({ data: locations })),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetAllLocationsFailed" } }), getLocationsInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public getDevicesForCompanyEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.GET_DEVICES_FOR_COMPANY),
        exhaustMap(({ data }) => this.inventoryManagementDevicesService.getAllDevicesByCompanyId(data)
          .pipe(
            map((devices: Device[]) => getDevicesForCompanyInventoryManagementSuccessAction({ data: devices })),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetAllDevicesForCompanyFailed" } }), getDevicesForCompanyInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public addDeviceToCompanyEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.ADD_DEVICE_TO_COMPANY),
        exhaustMap(({ data }) => this.inventoryManagementDevicePairingService.pairADeviceToACompany(data)
          .pipe(
            map((pairingStatusResponse: PairingStatusResponse) => addDeviceToCompanyInventoryManagementSuccessAction({ data: pairingStatusResponse })),
            catchError((error: HttpErrorResponse) => {
              return of(addDeviceToCompanyInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public updateDeviceNameEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.UPDATE_DEVICE_NAME),
        exhaustMap(({ data }) => this.inventoryManagementDevicesService.updateDeviceName(data)
          .pipe(
            map(() => updateDeviceNameInventoryManagementSuccessAction()),

            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.UpdateDeviceNameFailed" } }), updateDeviceNameInventoryManagementFailedAction())
            })            
          )
        )
      )
  );

  public deleteDeviceToCompanyEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.DELETE_DEVICE_FROM_COMPANY),
        exhaustMap(({ data }) => this.inventoryManagementDevicesService.removeDeviceFromCompany(data)
          .pipe(
            map(() => deleteDeviceFromCompanyInventoryManagementSuccessAction()),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.DeleteDeviceForCompanyFailed" } }), deleteDeviceFromCompanyInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public addLocationToDeviceEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.ADD_LOCATION_TO_DEVICE),
        exhaustMap(({ data }) => this.inventoryManagementDevicesService.linkDeviceToLocation(data)
          .pipe(
            map(() => addLocationToDeviceInventoryManagementSuccessAction()),
            catchError((error: HttpErrorResponse) => {
              return of(addLocationToDeviceInventoryManagementFailedAction())
            })
          )
        )
      )
  );

  public deleteLocationFromDeviceEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(InventoryManagementActionsTypes.DELETE_LOCATION_TO_DEVICE),
        exhaustMap(({ data }) => this.inventoryManagementDevicesService.unlinkDeviceFromLocation(data)
          .pipe(
            map(() => deleteLocationToDeviceInventoryManagementSuccessAction()),
            catchError((error: HttpErrorResponse) => {
              return of(deleteLocationToDeviceInventoryManagementFailedAction())
            })
          )
        )
      )
  );


  constructor(
    private actions$: Actions,
    private authenticationService: AuthenticationService,
    private inventoryManagementLocationsService: InventoryManagementLocationsService,
    private inventoryManagementDevicesService: InventoryManagementDevicesService,
    private inventoryManagementDevicePairingService: InventoryManagementDevicePairingService
  ) { }
}
